import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { paths } from '@AppRoutes/constants';
import history from '@AppRoutes/history';
import { TabGroup } from '@els/els-react--tab-group';
import { handleSearchInput } from '../HistoryAction';
import { trackAdobeAnalyticsPage } from '../analytics';

// TabGroup requires a `children` node (its tab panels). History renders its Recent/Saved
// content through the router below the tab bar
function EmptyTabPanel({ children, panelId, tabsId }) {
  return (
    <span className="sr-only" id={`tabpanel-${tabsId}-${panelId}`} role="tabpanel" aria-labelledby={`tab-${tabsId}-${panelId}`}>
      {children}
    </span>
  );
}

const HISTORY_TABS_ID = 'history-tabs';

function HeaderContainer() {
  const location = useLocation();
  const dispatch = useDispatch();
  const tabGroupRef = useRef();

  const handleLinkClick = (route) => {
    trackAdobeAnalyticsPage(route);
  };

  const tabs = [
    {
      id: 'recent',
      label: 'Recent',
      path: 'HISTORY_RECENT',
      route: 'main.history.recent',
    },
    {
      id: 'saved',
      label: 'Saved',
      path: 'HISTORY_SAVED',
      route: 'main.history.saved',
    },
  ];

  // Set active tab based on current route
  useEffect(() => {
    if (tabGroupRef.current) {
      const currentPath = location.pathname;
      let activeTabIndex = 0; // Default to Recent (index 0)

      if (currentPath === paths.HISTORY_SAVED) {
        activeTabIndex = 1; // Saved tab
      }

      tabGroupRef.current.setActiveTab(activeTabIndex);
    }
  }, [location.pathname]);

  // FR-3.2: the title and the Recent/Saved tab bar are rendered as SEPARATE siblings (a fragment)
  // rather than one wrapper, so the sticky tab bar's containing block is the tall parent `<main>`
  // (which spans header + content) instead of a short title-height box. If the tabs stayed nested
  // in `.heading-container--history`, `position: sticky` would un-pin the moment that short box
  // scrolled past. The title keeps its original wrapper/classes so it scrolls away unchanged.
  return (
    <>
      <div className="heading-container--history u-els-padding-top">
        <h1 id="history-title" className="u-els-font-size-h4">
          History
        </h1>
      </div>
      <div className="history-tabs-sticky">
        <TabGroup
          ref={tabGroupRef}
          id={HISTORY_TABS_ID}
          className="u-els-margin-top"
          isControlled
          label="History tabs"
          tabs={tabs?.map((tab) => (
            <span key={tab.id} id={tab.id}>
              {tab.label}
            </span>
          ))}
          hasDivider
          onTabChange={(s) => {
            // Clear search input when changing tabs
            dispatch(handleSearchInput(''));
            handleLinkClick(tabs[s]?.route);
            history.push(paths[tabs[s]?.path]);
          }}>
          {tabs.map((tab) => (
            <EmptyTabPanel key={tab.id} tabsId={HISTORY_TABS_ID}>
              {tab.label}
            </EmptyTabPanel>
          ))}
        </TabGroup>
      </div>
    </>
  );
}

export default HeaderContainer;
